import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { FeatureFlagContext } from '../context/FeatureFlagContext';

// Redirects to the homepage when the given feature flag is turned off,
// so a disabled feature's routes aren't reachable just by typing the URL.
const FeatureGate = ({ flagKey, children }) => {
  const { isEnabled } = useContext(FeatureFlagContext);
  if (!isEnabled(flagKey)) return <Navigate to="/" replace />;
  return children;
};

export default FeatureGate;
